import React from 'react';
import { Description, Image, Link, SubTitle } from '../../components/layouts';
import './style.scss';
import { getTrack } from '../../helpers';

const track = getTrack({ block: 2 });

export function Briefing() {
  return (
    <div className="page-section section-briefing inverted" data-track={track}>
      <div className="section-content center">
        <Description>
          vivo蔡司联合影像系统，超感光微云台双主摄：坐拥1亿像素模式、114°大视野，<br/>搭载5nm高通骁龙888旗舰芯片，让超感体验，震撼来袭！
        </Description>
        <div className="links">
          <Link bordered href="https://shop.vivo.com.cn/product/10006210" text="官网购买" position={2} />
          <Link bordered href="http://www.vivo.com.cn/store" text="门店购买" position={2} />
        </div>
      </div>
    </div>
  );
}

